module.exports = __webpack_public_path__ + "static/media/carroussel_04.27648325.jpg";